// extracted by mini-css-extract-plugin
module.exports = {"container":"e_-3","placeholder":"e_a4","embed":"e_b4"};